
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/profile/[username]",
      function () {
        return require("private-next-pages/profile/[username].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/profile/[username]"])
      });
    }
  